<script lang="ts">
  import classnames from "classnames"
  import { omit } from "$lib/utils/object";
  // Components
  import { Grid } from '$lib/components/organisms/Layout';

  export let variant: "transparent" | "white" = "white"
  export let compact = false
  export let tighter = false
  /* Extend the mobile grid beyond page margins */
  export let extended = false

  const attributes = omit($$restProps, "class")
</script>

<section
  class="{classnames('section-compact', $$props.class)}"
  class:tighter
  class:v-white="{variant === 'white'}"
  {...attributes}
>
  <Grid>
    <div class="grid-inner">
      {#if $$slots.header}
        <div class="header" class:compact>
          <slot name="header" />
        </div>
      {/if}
      <div class="content" class:extended>
        <slot />
      </div>
      {#if $$slots.footer}
        <div class="footer grid gap-y-4 xs:flex xs:justify-end xs:space-x-8">
          <slot name="footer" />
        </div>
      {/if}
      {#if $$slots.footerCentered}
        <div class="footer grid gap-y-4 xs:flex xs:justify-center xs:space-x-8">
          <slot name="footerCentered" />
        </div>
      {/if}
    </div>
  </Grid>
</section>

<style type="text/scss" lang="scss" scoped>
  .section-compact {
    &.v-white {
      @apply relative;
      @apply bg-white;

      &:before {
        content: "";
        @apply md:block;
        @apply md:bg-white;
        @apply md:absolute inset-y-0 left-0;

        @screen lg {
          width: calc((100vw - var(--page-current-width)) / 2 + var(--page-margin));
          margin-left: calc((100vw - var(--page-current-width)) * -0.5 - var(--page-margin));
        }
      }
    }

    &:not(.tighter) .grid-inner {
      @apply col-span-full lg:col-start-2 lg:col-span-10;
    }

    &.tighter .grid-inner {
      @apply col-span-full lg:col-start-3 lg:col-span-8;
    }
  }

  .content {
    &.extended {
      @apply -page-margin md:mx-0;
    }
  }

  .header {
    &:not(.compact) {
      @apply mb-5 md:mb-14;
    }

    &.compact {
      @apply mb-4 md:mb-6;
    }
  }

  .indicators {
    @apply flex justify-end;
  }

  .footer {
    @apply mt-6 md:mt-8;
  }
</style>
